export interface RequestRouteListInterface {
  countrySlug?: string;
  citySlug?: string;
  departureAirportCode?: string;
  arrivalAirportCode?: string;
  airlineCode?: string;
  limit?: string;
}

interface Route {
  title: string;
  slug: string;
  count: number;
}

export class ResponseRouteList {
  status: boolean;

  code: string = "";

  message: string;

  data: Route[] | null = null;

  constructor(data?: ResponseRouteList) {
    this.data = data?.data || null;
    this.message = data?.message || "";
    this.status = data?.status || false;
  }
}
